<template>
  <MyAccountProfileLinksMobile v-if="isMobileOrTablet" />
  <MyAccountProfileLinksDesktop v-else />
</template>

<script setup lang="ts">
const { isMobileOrTablet } = useDevice()
</script>
